import { Link } from "react-router-dom";
import { siteInfo, categoryList } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-fire-line w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="font-heading text-lg font-bold">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
              {siteInfo.description}
            </p>
            <p className="mt-4 text-xs text-background-300">最近更新：{siteInfo.updatedAt}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100">
              <Link to="/">网站导航</Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li><Link to="/" className="transition-colors hover:text-accent-300">首页</Link></li>
              <li><Link to="/rankings" className="transition-colors hover:text-accent-300">热搜榜单</Link></li>
              <li><Link to="/articles" className="transition-colors hover:text-accent-300">吃瓜资讯</Link></li>
              <li><Link to="/faq" className="transition-colors hover:text-accent-300">常见问题</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-accent-300">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100">
              <Link to="/articles">热门分类</Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              {categoryList.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/articles?category=${cat.slug}`}
                    className="transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                </span>
                <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-accent-300">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-weibo-line w-5 h-5 flex items-center justify-center"></i>
                </span>
                <span>{siteInfo.weibo}</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-wechat-line w-5 h-5 flex items-center justify-center"></i>
                </span>
                <span>{siteInfo.wechat}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteInfo.name}. 内容仅供参考，不构成任何事实认定。</p>
          <p>本站内容由编辑团队整理，欢迎邮件反馈线索与建议。</p>
        </div>
      </div>
    </footer>
  );
}